export const Navbar = () => <div class="venue-navbar-wrapper">
	<div class="topnavtk2 left-nav" id="myTopnavtk2">
		<a href="https://quadient.tkeventsregistration.com/inspire2021" id="LeaveEvent" class="activetk2">Leave Event</a>

		{/* <div class="dropdowntk2">
			<button class="dropbtntk2">Agendas
				<i class="fa fa-caret-down" />
			</button>
			<div class="dropdown-contenttk2">
				<a href="https://quadient.tkeventsregistration.com/inspire2021/emeaagendav" title="EMEA Agenda">EMEA Agenda</a>
				<a href="https://quadient.tkeventsregistration.com/inspire2021/apacagendav" title="APAC Agenda">APAC Agenda</a>
				<a href="https://quadient.tkeventsregistration.com/inspire2021/ameragendav" title="AMER Agenda">AMER Agenda</a>
			</div>
		</div> */}

		<a href="/lobby" title="Lobby">Lobby</a>
		<div class="dropdowntk2">
			<button class="dropbtntk2">Venue Navigation
				<i class="fa fa-caret-down" />
			</button>
			<div class="dropdown-contenttk2">
				{/* <a class="_gtm-event" href="/main-stage" title="Main Stage" onClick={() => window.openChat("main-stage")} >Main Stage</a> */}
				<a class="_gtm-event" href="/exhibition-hall" title="Exhibition Hall">Exhibition Hall</a>
				<a class="_gtm-event" href="/resource-hub" title="Resource Hub">Resource Hub</a>
				{/* <a class="_gtm-event" href="/networking" title="Networking" onClick={() => window.openChat("product")}>Networking</a>
				<a class="_gtm-event" href="/demo-theatre" title="Demo Theatre">Demo Theatre</a> */}
			</div>
		</div>
		{/* <div class="dropdowntk2">
			<button class="dropbtntk2">Breakouts
				<i class="fa fa-caret-down" />
			</button>
			<div class="dropdown-contenttk2">
				<a class="_gtm-event" href="/breakouts" title="Breakout Foyer">Breakout Foyer</a>
				<a class="_gtm-event" href="/breakout-one" title="ccm apprentices" onClick={() => window.openChat("ccm")}>ccm apprentices</a>
				<a class="_gtm-event" href="/breakout-two" title="cxperts" onClick={() => window.openChat("experts")}>cxperts</a>
				<a class="_gtm-event" href="/breakout-three" title="tech masterclass" onClick={() => window.openChat("tech")}>tech masterclass</a>
				<a class="_gtm-event" href="/breakout-four" title="best practices" onClick={() => window.openChat("best")}>best practices</a>
			</div>
		</div> */}

		<a class="_gtm-event" href="https://quadient.tkeventsregistration.com/inspire2021/sponsorsv" title="Sponsor Directory">
			Sponsor Directory
		</a>
		{/* <a class="_gtm-event" style="cursor: pointer" id="quadient2021-languages" title="Language Management">Language Management</a> */}
		<a class="_gtm-event" target="_blank" href="https://quadient.tkeventsregistration.com/feedbackform21" title="Session Feedback">Session Feedback
		</a>
		<a class="_gtm-event" target="_blank" href="https://quadient.tkeventsregistration.com/inspire2021/ondemand" title="On-Demand Portal">
			On-Demand Portal
		</a>
	</div>
	{/* <div class="gamification-buttons-wrapper topnavtk2">
		<a class="gamification-button leadBtn _gtm-event" id="quadient2021-scav-hunt" title="Scavenger Hunt Instructions">Scavenger Hunt Instructions</a>
		<a class="gamification-button _gtm-event" href="#submit-answers" id="quadient2021-scav-hunt-submit" title="Submit Answers">Submit Answers</a>
	</div> */}
</div>
